import { Col, Layout, Progress, Row, Tag } from 'antd';
import { Permission } from '../../apis/mgmt/api';
import { ClickableProps, DataViewProps } from '../common/DataView';
import { CalendarOutlined, MailOutlined, ToolOutlined, UserOutlined } from '@ant-design/icons';
import { Content } from 'antd/es/layout/layout';


export const PermissionCard = function (props:
    DataViewProps<Permission> & ClickableProps<Permission>
) {

    const data = props.data;
    const onClick = () => { data && props.onClick && props.onClick(data); }

    return data && (
        <Col key={data.id} xs={24} sm={24} md={12} lg={8} xl={8}>
            <Layout>
                <div className={"mig-card pointer mig-border "} onClick={onClick}>

                    <Content>
                        <Row >
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <div className={'mig-card-content pointer'} >
                                    <span className='mig-title-3'><Tag color=""><ToolOutlined /> {data?.role?.level}</Tag> {data.user?.username}</span>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                            <small style={{ fontStyle: "oblique", marginRight: "1em" }}><MailOutlined /> {data.user?.email}</small>
                            </Col>

                        </Row>
                    </Content>

                </div>
            </Layout>
        </Col>
    ) || null;
}